import React from 'react';

import styled from '../../theme/styled-with-theme';

import { BlockContainer, Column, Layout } from '../Layout';

const StyledHorizontalRule = styled('hr')`
  border-top: 1px solid ${({ theme }) => theme.color.black};
  width: 100%;
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export function HorizontalRule() {
  return (
    <BlockContainer data-testid="horizontal-rule">
      <Layout>
        <Column size={{ 0: 10, desktop: 10 }} flexDirection="column">
          <StyledHorizontalRule />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
